import { Button, Dialog, Flex, Text } from '@servicetitan/anvil2';
import illustration from './invoice.svg';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { providerIdToName } from '@servicetitan/financing-utils-shared';
import { useRedirectToPostApplication } from './redirectToPostApplication';

interface OpenApplicationConfirmationDialogProps {
    onReturnToProposals: () => void;
}

export const OpenApplicationConfirmationDialog = ({
    onReturnToProposals: onReturnToProposals,
}: OpenApplicationConfirmationDialogProps) => {
    const { setupData } = SetupDataStore.useStore();
    const redirectToPostApplication = useRedirectToPostApplication();
    const isTechnician = setupData?.role === 'technician';

    return (
        <>
            <Dialog.Header />
            <Dialog.Content>
                <Flex direction="column" gap="3" alignItems="center">
                    <img src={illustration} alt="Complete your application" width="134" />
                    <Text variant="headline" el="h2">
                        Complete your application
                    </Text>
                    <Text variant="body" style={{ textAlign: 'center' }}>
                        Complete your application on the {providerIdToName(setupData!.provider)}{' '}
                        website. When you’re finished, you can return to your proposals to sign and
                        accept an estimate.
                    </Text>
                </Flex>
            </Dialog.Content>
            <Dialog.Footer>
                <Flex justifyContent="space-between" style={{ width: '100%' }}>
                    <Dialog.CancelButton>Back</Dialog.CancelButton>
                    {isTechnician ? (
                        <Button appearance="primary" onClick={redirectToPostApplication}>
                            Continue
                        </Button>
                    ) : (
                        <Button appearance="primary" onClick={onReturnToProposals}>
                            Return to Proposals
                        </Button>
                    )}
                </Flex>
            </Dialog.Footer>
        </>
    );
};
